/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
// This controller uses stimulus-carousel (a wrapper around Swiper.js) to handle
// the layout, navigation, and slide behavior of the week activity cards on the
// competitors page.
//
// Using this prebuilt solution helps us avoid reinventing the wheel for carousel logic,
// including slide grouping, navigation, and responsiveness.
// For usage, see:
// - `activity_cards.html.haml` (partial)
// - `competitors_feeds/show.html.haml` (view)
// References:
// - https://www.stimulus-components.com/docs/stimulus-carousel
// - https://swiperjs.com/element
import Rails from '@rails/ujs';
import Carousel from "@stimulus-components/carousel"
import type { SwiperOptions } from "swiper/types/swiper-options"

export default class extends Carousel {
  static targets = ["prevNavigation", "nextNavigation"];
  static values = {
    displayNavigation: Boolean
  };

  declare displayNavigationValue: boolean;
  declare prevNavigationTarget: HTMLButtonElement;
  declare nextNavigationTarget: HTMLButtonElement;

  // @ts-expect-error: defaultOptions override is safe,
  // we don’t need full Swiper instance
  get defaultOptions(): SwiperOptions {
    return {
      direction: "horizontal",
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 32,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    }
  }

  connect() {
    // This.swiper is initialized during super.connect()
    super.connect();

    if (this.displayNavigationValue) {
      this.swiper.on("slideChange", this.handleSlideChange.bind(this));
    }
  }

  disconnect(): void {
    // Clean up the swiper instance when the controller is disconnected
    this.swiper.off("slideChange", this.handleSlideChange.bind(this));
    super.disconnect();
  }

  // Adjust the navigation button visibility and state:
  // - Hide the previous button at the start
  // - Disable the next button at the end
  // Ensures navigation accurately reflects the current swiper position
  handleSlideChange() {
    // Handle previous button styles
    if (this.swiper.isBeginning) {
      this.prevNavigationTarget.classList.add("hidden");
    } else {
      this.prevNavigationTarget.classList.remove("hidden");
    }
  }

  handleCarouselClick(): void {
    setTimeout(() => {
      void fetch("competitors_feed/carousel_clicked", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-Requested-With": "XMLHttpRequest",
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          "X-CSRF-TOKEN": Rails.csrfToken(),
        }
      });
    }, 0);
  }
}
